import { object, string, number, array } from "yup";
import { BooleanSwitchValue } from "consts/general";
import { FormField } from "./types";
import { useBankingValidationSchema } from "../shared";

const useValidationSchema = () =>
    useBankingValidationSchema()
        .concat(
            object().shape({
                [FormField.AisOptions]: object()
                    .nullable()
                    .label('AIS Options'),

                [FormField.PisOptions]: object()
                    .nullable()
                    .label('PIS Options'),

                [FormField.CountryIso]: array()
                    .of(string())
                    .min(1)
                    .nullable()
                    .label('Country ISO'),

                [FormField.Flow]: object()
                    .nullable()
                    .label('Flow'),

                [FormField.IsEnabled]: number()
                    .oneOf([BooleanSwitchValue.Off, BooleanSwitchValue.On])
                    .label('Is Enabled'),

                [FormField.Obs]: string()
                    .optional()
                    .label('Obs'),

                [FormField.ShouldCreditOnRedirect]: number()
                    .oneOf([BooleanSwitchValue.Off, BooleanSwitchValue.On])
                    .label('Should Credit Redirect'),

                [FormField.Status]: number()
                    .required()
                    .label('Status')
            })
        );

export default useValidationSchema;

